import { render, staticRenderFns } from "./addanadmin.vue?vue&type=template&id=39c87de0&scoped=true"
import script from "./addanadmin.vue?vue&type=script&lang=js"
export * from "./addanadmin.vue?vue&type=script&lang=js"
import style0 from "./addanadmin.vue?vue&type=style&index=0&id=39c87de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c87de0",
  null
  
)

export default component.exports